import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Autocomplete,
  TextField,
  Avatar,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "../../sharedComponents/LoadingButton/loadingButton";
import * as Yup from "yup";
import { postClient, updateClient } from "../../services/client.service";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import { getProject } from "../../services/project.service";

import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";

import NoProfile from "../../assets/images/No_Profile.svg";
import Delete_Icon from "../../assets/images/Task_File_Delete_Icon.svg";
const AddClient = (props) => {
  const { setOpenDrawer, formType, selectedData, getData } = props;
  const formRef = useRef(null);

  const disabled = formType === "view";
  const [loading, setLoading] = useState(false);
  const [projectData, setProjectData] = useState([]);
  const [initialValues, setInitialValues] = useState({
    name: "",
    userName: "",
    email: "",
    mobileNo: "",
    project: "",
    ProjectReports: [],
    password: "",
    confirmPassword: "",
    file: [],
  });

  const [tempImage, setTempImage] = useState(null);
  const [fileName, setFileName] = useState();
  // {formType === "edit"
  // ? selectedData?.file?.fileName
  // : "Drag & Drop or click to upload videos"}

  const renderFile = (file) => {
    if (tempImage) {
      return (
        <img
          src={tempImage}
          alt={fileName || "Temporary Image"}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            cursor: "pointer",
          }}
        />
      );
    }
    if (!file?.location) return <img src={NoProfile} alt="No_Profile" />;
    return (
      <img
        src={file.location}
        alt={file.fileName || "No Profile"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          cursor: "pointer",
        }}
      // onClick={() => handleImageClick(file.location)}
      />
    );
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name Required *"),
    // userName: Yup.string().required("User Name Required *"),
    email: Yup.string()
      .required("Please enter email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address"
      ),
    // mobileNo: Yup.string()
    //   .required("Mobile Number is required")
    //   .min(10, "Mobile Number must be at least 10 characters")
    //   .max(10, "Mobile Number must be 10 characters"),
    mobileNo: Yup.string()
      .required("Mobile Number is required")
      .matches(/^[0-9]+$/, "Mobile Number must be a valid number")
      .min(10, "Mobile Number must be at least 10 digits")
      .max(15, "Mobile Number can't be more than 15 digits"),
    project: Yup.array()
      .of(Yup.string().required("Project Required *"))
      .required("Project Required *"),
    ProjectReports: Yup.array()
      .of(Yup.string())
      .min(1, "At least one Project Report is required")
      .required("Project Reports Required *"),
    // password: Yup.string().when("formType", {
    //   is: "edit", // Apply validation only if formType is 'edit'
    //   then: Yup.string().required("Password Required *"),
    //   otherwise: Yup.string().notRequired(), // Don't require password for other form types
    // }),

    // confirmPassword: Yup.string().when("formType", {
    //   is: "edit", // Apply validation only if formType is 'edit'
    //   then: Yup.string()
    //       .required("Confirm Password is required")
    //     .oneOf([Yup.ref("password"), null], "Password does not match"),
    //   otherwise: Yup.string().notRequired(), // Don't require confirmPassword for other form types
    // }),
    password: Yup.string().required("Password Required *"),

    // Add confirmPassword validation
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });
  const validationSchema2 = Yup.object().shape({
    name: Yup.string().required("Name Required *"),
    // userName: Yup.string().required("User Name Required *"),
    email: Yup.string()
      .required("Please enter email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address"
      ),
    // mobileNo: Yup.string()
    //   .required("Mobile Number is required")
    //   .min(10, "Mobile Number must be at least 10 characters")
    //   .max(10, "Mobile Number must be 10 characters"),
    mobileNo: Yup.string()
      .required("Mobile Number is required")
      .matches(/^[0-9]+$/, "Mobile Number must be a valid number")
      .min(10, "Mobile Number must be at least 10 digits")
      .max(15, "Mobile Number can't be more than 15 digits"),
    project: Yup.array()
      .of(Yup.string().required("Project Required *"))
      .required("Project Required *"),
    ProjectReports: Yup.array()
      .of(Yup.string())
      .min(1, "At least one Project Report is required")
      .required("Project Reports Required *"),
  });

  const getProjectData = async () => {
    try {
      const res = await getProject({ isEnabled: true });
      const configData = res.data.data.map((e) => {
        return {
          ...e,
          label: e.name,
        };
      });
      setProjectData(configData);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getProjectData();
    if (formType === "edit" || formType === "view") {
      setInitialValues({
        name: selectedData.name || "",
        email: selectedData.email || "",
        mobileNo: selectedData.mobileNo || "",
        project: Array.isArray(selectedData.project)
          ? selectedData.project.map((proj) => proj._id)
          : [],
        ProjectReports: Array.isArray(selectedData.ProjectReports)
          ? selectedData.ProjectReports.map((proj) => proj._id)
          : [],
        // password: selectedData.password || "",
        // confirmPassword: selectedData.password || "",
      });
    }
  }, [formType, selectedData]);

  const onSubmit = async (values) => {
    try {
      const formData = new FormData();
      const { file, name, email, mobileNo, ...bodyData } = values;
      const encryptedData = {
        name: (name),
        email: (email),
        mobileNo: (mobileNo),
      };
      console.log(values.email);
      const filteredBodyData = Object.fromEntries(
        Object.entries({ ...bodyData, ...encryptedData }).filter(
          ([key, value]) => value !== ""
        )
      );

      // if (file === null || file) {
      // formData.append("file", file);
      // }
      if (file) {
        formData.append("file", file);
      }
      formData.append("bodyData", JSON.stringify(filteredBodyData));

      const apiMethod =
        formType === "edit"
          ? updateClient(selectedData._id, formData)
          : postClient(formData);
      const res = await apiMethod;
      console.log("yyy", res);
      setLoading(false);
      ToastSuccess(res.message);
      getData();
      setOpenDrawer(false);
    } catch (error) {
      ToastError(error?.data?.message);
    }
  };

  // const onSubmit = async (values) => {
  //   setLoading(true);
  //   console.log(values, "CV");
  //   try {
  //     const apiMethod =
  //       formType === "edit"
  //         ? updateClient(selectedData._id, values)
  //         : postClient(values);
  //     const res = await apiMethod;
  //     setLoading(false);
  //     ToastSuccess(res.message);
  //     getData();
  //     setOpenDrawer(false);
  //   } catch (error) {
  //     setLoading(false);
  //     ToastError(error.data.message);
  //   }
  // };

  return (
    <div className="addRenderingPopup">
      <Box className="addContainerHeader">
        <Typography className="headerTitle">
          {formType === "view" ? "View" : formType === "edit" ? "Edit" : "Add"}{" "}
          Client
        </Typography>
        <Grid className="Close-Icon">
          <CloseIcon
            sx={{ width: "20px", height: "20px" }}
            onClick={() => setOpenDrawer(false)}
          />
        </Grid>
      </Box>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={
          formType === "add" ? validationSchema : validationSchema2
        }
        onSubmit={onSubmit}
        innerRef={formRef}
      >
        {({ touched, errors, setFieldValue, values }) => (
          <Form>
            <Box className="addContainerCenter" mb={1}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} mt={1}>
                  <Grid item xs={12} sm={12} mt={1}>
                    <div className="wsh-form-control">
                      <Typography className="inputLabel">
                        Name <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Field
                        name="name"
                        disabled={disabled}
                        className="InputField w-100"
                        placeholder="Enter Name"
                      />
                      <div className="form-error">
                        {touched.name && errors.name && errors.name}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} mt={1}>
                    <div className="wsh-form-control">
                      <Typography className="inputLabel">
                        E-mail <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Field
                        name="email"
                        disabled={disabled}
                        className="InputField w-100"
                        placeholder="Enter E-mail"
                      />
                      <div className="form-error">
                        {touched.email && errors.email && errors.email}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} mt={1}>
                    <div className="wsh-form-control">
                      <Typography className="inputLabel">
                        Mobile No <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Field
                        name="mobileNo"
                        disabled={disabled}
                        className="InputField w-100"
                        placeholder="Enter Mobile No"
                      />
                      <div className="form-error">
                        {touched.mobileNo && errors.mobileNo && errors.mobileNo}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} mt={1}>
                    <div className="wsh-form-control">
                      <Typography className="inputLabel">
                        Project <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Autocomplete
                        options={projectData}
                        multiple
                        disabled={disabled}
                        getOptionLabel={(option) => option.label || option.name} // Ensure this displays the correct label
                        value={projectData.filter((option) =>
                          values.project.includes(option._id)
                        )}
                        onChange={(event, newValue) => {
                          // Map the selected project objects to their IDs
                          setFieldValue(
                            "project",
                            newValue.map((option) => option._id)
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            focused={false}
                            placeholder="Select Project"
                            className="AutoComplete_InputBox"
                          />
                        )}
                      />
                      <div className="form-error">
                        {touched.project && errors.project && errors.project}
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} mt={1}>
                    <div className="wsh-form-control">
                      <Typography className="inputLabel">
                        Project Reports <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Autocomplete
                        options={projectData}
                        multiple
                        disabled={disabled}
                        getOptionLabel={(option) => option.label || option.name}
                        value={projectData.filter((option) =>
                          values.ProjectReports.includes(option._id)
                        )}
                        onChange={(event, newValue) => {
                          // Map the selected project objects to their IDs
                          setFieldValue(
                            "ProjectReports",
                            newValue.map((option) => option._id)
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            focused={false}
                            placeholder="Select Project Reports"
                            className="AutoComplete_InputBox"
                          />
                        )}
                      />
                      <div className="form-error">
                        {touched.ProjectReports && errors.ProjectReports && errors.ProjectReports}
                      </div>
                    </div>
                  </Grid>
                </Grid>
                {/* <Grid item xs={12} sm={6} mt={1}>
                  <div className="wsh-form-control">
                    <Typography className="inputLabel">User Name</Typography>
                    <Field
                      name="userName"
                      disabled={disabled}
                      className="InputField w-100"
                      placeholder="Enter User Name"
                    />
                    <div className="form-error">
                      {touched.userName && errors.userName && errors.userName}
                    </div>
                  </div>
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    mt={1}
                    sx={{
                      display: "flex",
                      // alignItems: "center",
                      // alignContent: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* <div className="wsh-form-control"> */}
                    {/* <Typography className="inputLabel">Add Profile</Typography> */}
                    {/* <FileUploader
                    handleChange={(e) => {
                      const files = e instanceof FileList ? Array.from(e) : [e];
                      setFieldValue("files", files);
                      setFileName(files.map((file) => file.name).join(", "));
                    }}
                    name="files"
                    multiple={true}
                    dropMessageStyle={{
                      color: "green",
                      border: "none",
                      borderRadius: "0px",
                    }}
                  /> */}
                    <Grid>
                      <Box
                        sx={{
                          display: "flex", // To center the content
                          justifyContent: "center", // Center avatar horizontally
                          alignItems: "center", // Center avatar vertically
                          position: "relative", // To position the delete icon properly
                        }}
                      >
                        <Avatar
                          sx={{
                            width: 90, // Set the width of the avatar
                            height: 90, // Set the height of the avatar (should match width for a circle)
                            borderRadius: "50%", // Ensure the avatar is circular
                            overflow: "hidden",
                          }}
                        >
                          {renderFile(selectedData?.file)}{" "}
                        </Avatar>

                        {/* Delete Icon positioned on top of the Avatar */}
                        <Box
                          sx={{
                            position: "absolute", // Position it on top of the avatar
                            top: 0,
                            right: 0,
                            cursor: "pointer", // Make the icon clickable
                            padding: "4px", // Padding for the icon (optional)
                          }}
                        >
                          <img
                            src={Delete_Icon}
                            alt={"Delete_Icon"}
                            onClick={() => {
                              setFieldValue("file", null);
                              setTempImage(null);
                            }}
                            style={{
                              width: 20, // Set the width of the delete icon
                              height: 20, // Set the height of the delete icon
                              background: "#DBDADA",
                              borderRadius: "50%",
                              color: "red",
                              padding: 2,
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                    {/* <Box className="uploadIcon">
                    <CloudUploadOutlinedIcon />
                    {fileName ? (
                      <span>{fileName}</span>
                    ) : (
                      "Drag & Drop or click to upload files"
                    )}
                  </Box> */}
                    {/* <div className="form-error">
                        {touched.file && errors.file && errors.file}
                      </div>
                    </div> */}
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={12}
                    mt={2}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      // sx={{
                      //   color: "#fff",
                      //   // backgroundColor: tempImage ? "#008080" : "#999",
                      //   backgroundColor: "#008080",
                      //   textTransform: "none",
                      //   // width: "50% !important",
                      // }}
                      className="Add-Button-Popup"
                      component="label"
                      startIcon={<BorderColorOutlinedIcon />}
                    >
                      {formType === "add" ? "Add Photo" : "Edit Photo"}
                      <input
                        type="file"
                        hidden
                        onChange={(e) => {
                          const files = e.target.files[0];
                          if (files) {
                            // Generate a temporary URL for preview
                            const tempUrl = URL.createObjectURL(files);
                            setTempImage(tempUrl);
                            setFileName(files.name);
                            setFieldValue("file", files);
                          }
                        }}
                      />
                    </Button>
                  </Grid>

                  {(formType === "add" || formType === "edit") && (
                    <>
                      <Grid item xs={12} sm={12} mt={1}>
                        <div className="wsh-form-control">
                          <Typography className="inputLabel">
                            Password <span style={{ color: "red" }}>*</span>
                          </Typography>
                          <Field
                            name="password"
                            disabled={disabled}
                            className="InputField w-100"
                            placeholder="Enter Password"
                          />
                          <div className="form-error">
                            {touched.password &&
                              errors.password &&
                              errors.password}
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} mt={1}>
                        <div className="wsh-form-control">
                          <Typography className="inputLabel">
                            Confirm Password{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Typography>
                          <Field
                            name="confirmPassword"
                            disabled={disabled}
                            className="InputField w-100"
                            placeholder="Enter Confirm Password"
                          />
                          <div className="form-error">
                            {touched.confirmPassword &&
                              errors.confirmPassword &&
                              errors.confirmPassword}
                          </div>
                        </div>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Box>
            <Grid className="addboxFooter">
              <Button
                className="cancelButton"
                onClick={() => setOpenDrawer(false)}
              >
                Cancel
              </Button>
              <LoadingButton
                type="submit"
                className="saveButton"
                loading={loading}
                sx={{ display: formType === "view" ? "none" : "flex" }}
              >
                Save
              </LoadingButton>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddClient;
